import keyMirror from 'key-mirror';

export default keyMirror({
  intervene: null,
  assessment: null,
  instruction: null
});
